import React, { forwardRef } from 'react';
import InputMask from 'react-input-mask';

const CNPJMaskInput = forwardRef(
  ({ value, onChange, disabled, readOnly, size, ...rest }, ref) => {
    const sizeClass =
      size === 'sm'
        ? 'form-control-sm'
        : size === 'lg'
        ? 'form-control-lg'
        : '';
    const className = `form-control ${sizeClass}`.trim();

    return (
      <InputMask
        mask="99.999.999/9999-99"
        value={value}
        onChange={onChange}
        disabled={disabled}
        readOnly={readOnly}
      >
        {inputProps => (
          <input {...inputProps} {...rest} ref={ref} className={className} />
        )}
      </InputMask>
    );
  }
);

export default CNPJMaskInput;
